import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export const AppointmentForm = () => {
  const [AppointmentFormUser, setAppointmentFormUser] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get("https://admin.gosaviadvanceddentalclinic.com/api/getAppointmentForm");
      setAppointmentFormUser(response.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      await axios.delete(`https://admin.gosaviadvanceddentalclinic.com/api/deleteAppointmentForm/${userId}`);

      setAppointmentFormUser((prevUsers) =>
        prevUsers.filter((user) => user.id !== userId)
      );

      toast.error("Data Deleted Successfully!");
      navigate("/AppointmentForm");
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete data!");
    }
  };

  return (
    <div className="container homeBanner-details">
      <div className="row arpi">
        <div className="col-lg-2 col-md-2 col-sm-12"></div>

        <div className="col-lg-10 col-md-10 col-sm-12 view-home">
            <h2>Appointment Form Data</h2>
          <div className="row table-home">
            <table>
              <thead>
                <tr>
                  <th className="col-lg-1">Sr.No</th>
                  <th className="col-lg-2">Full Name</th>
                  <th className="col-lg-2">Email</th>
                  <th className="col-lg-2">Date</th>
                  <th className="col-lg-2">Time</th>
                  <th className="col-lg-3">Message</th>
                  <th className="col-lg-1">Action</th>
                </tr>
              </thead>
              <tbody>
                {AppointmentFormUser.map((user, index) => {
                  return (
                    <tr key={user.id}>
                      <td>{index + 1}</td>
                      <td>{user.fullname}
                      </td>
                      <td>{user.email}</td>
                      <td>
                       {user.date}
                      </td>
                      <td>
                       {user.time}
                      </td>
                      <td>{user.message}</td>
                      <td>
                        <span onClick={() => deleteUser(user.id)}>
                          <i
                            title="Delete"
                            className="fa-solid fa-trash-can action-btn"
                            style={{ color: "red" }}
                          ></i>
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};